import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export default function FieldCard({ sectionId, field, selected, onSelect }) {
  const sortableId = `field:${sectionId}:${field.id}`;
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: sortableId,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.65 : 1,
  };

  return (
    <button
      ref={setNodeRef}
      type="button"
      style={style}
      onClick={onSelect}
      className={`w-full rounded-lg border px-3 py-2 text-left ${
        selected ? "border-blue-600 bg-blue-50" : "border-gray-200 bg-white hover:bg-gray-50"
      }`}
      {...attributes}
      {...listeners}
    >
      <p className="text-xs uppercase tracking-wide text-gray-500">{field.type}</p>
      <p className="mt-1 text-sm font-semibold text-gray-900">{field.label || "Onbenoemd veld"}</p>
      <p className="mt-1 text-xs text-gray-500">
        {field.required ? "Verplicht" : "Optioneel"}
        {field.type === "photo" && field.multiple ? " | meerdere foto's" : ""}
      </p>
    </button>
  );
}
